import i18n from 'services/base/i18n';

export default {
  ok: () => i18n.pgettext('Components|Calendar', 'OK'),
};
